export var createStyles = function (styles) {
    return styles;
};
